import * as React from 'react';
import NewJobPricelistItemData from './NewJobPricelistItem';
import { ItemOptionList, NewJobQuoteItem, NewJobQuoteFenceQuestions } from './models/JobInterfaces';

interface NewJobPricelistCameraProps {
    isJobEvent: boolean;
    jobTypeId: number;
    accountTypeId: number;
    customerQuoteNotesDunny: string;
    scheduleDateDefaultDays: number;
    schedulePickup: boolean;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    cameraLocation: string;
    truckHireRate: number;
    fenceQuestions: NewJobQuoteFenceQuestions;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    customerChargeFuelSurcharge: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    errors: { [key: string]: string };
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    updateCameraLocation(cameraLocation: string): void;
}

const NewJobPricelistCameraData = (props: NewJobPricelistCameraProps) => {

    const pricelistItem = <NewJobPricelistItemData isJobEvent={props.isJobEvent} jobTypeId={props.jobTypeId} scheduleDateDefaultDays={props.scheduleDateDefaultDays} schedulePickup={props.schedulePickup}
        lunchRoomExtraId={0} siteOfficeExtraId={0} showLocation={false} showExtras={false} showCleaning={false} showBracing={false} showMaintenance={false} showTruck={false} showEpaItems={false} showAdditionalHire={true}
        customerPickup={-1} allowAllocateToPastDate={props.allowAllocateToPastDate} jobInstalled={props.jobInstalled} accountTypeId={props.accountTypeId} quoteItems={props.quoteItems} itemOptions={props.itemOptions}
        truckHireRate={props.truckHireRate} fenceQuestions={props.fenceQuestions} frequencyOptions={[]} extraItemOptions={[]} yesNoOptions={[]} truckOptions={[]} truckSideOptions={[]}
        chargeFuelSurchargeSwitchedOn={props.chargeFuelSurchargeSwitchedOn} customerChargeFuelSurcharge={props.customerChargeFuelSurcharge}
        addItem={props.addItem} deleteItem={props.deleteItem} updateQuoteItem={props.updateQuoteItem} />

    return (
        <div>
          
            <div className="newJobPricelist--customer-notes">{props.customerQuoteNotesDunny}</div>

            {pricelistItem}
            {props.errors["cameraQuoteItems"] ?
                (props.errors["cameraQuoteItems"]).split("\n").map((item: any, key: any) => {
                    return <span className="label errors" key={key}>{item}<br /></span>
                })
                : ""}

            <label className="input-group" htmlFor="cameraLocation">
                <span className="label-large">Where is the preferred location on site?</span>
                <input className="input" type="text" maxLength={200} id="cameraLocation" name="cameraLocation" value={props.cameraLocation} onChange={(e) => props.updateCameraLocation(e.target.value)}></input>
            </label>
            <span className="label errors">{props.errors["cameraLocation"]}</span>
        </div>
    )

}

export default NewJobPricelistCameraData;